<template>
  <div class="background">
    <v-dialog :fullscreen="$vuetify.breakpoint.mobile"
              :value="editDialogClienteOpened"
              max-width="800px"
              persistent>
      <v-card class="d-flex flex-column"
        :loading="loadingFormCliente">
        <v-card-title>
          Inscreva-se
          <v-spacer/>
          <v-btn icon @click="editDialogClienteOpened=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="py-4 flex-grow-1" v-if="editDialogClienteOpened">
          <v-form ref="form" @submit.prevent="saveCliente" v-model="formClienteValid" lazy-validation>
            <cadastre-se-form v-model="formCliente"/>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn v-show="botoesCadastroClienteVisivel" outlined color="primary" @click="editDialogClienteOpened=false">Cancelar</v-btn>
          <v-btn v-show="botoesCadastroClienteVisivel" color="primary" @click="saveCliente" :disabled="!formClienteValid">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container class="spacing-playground pa-lg-10" fluid>
      <v-card class="d-flex flex-column"
                :loading="loading">
        <v-card-title>
          <div class="logo">
            <app-logo/>
          </div>
          Bem vindo a área de {{ descEvento("titulo") }} 
        </v-card-title>
        <v-divider/>
        <div v-if="!existeCompeticaoativa" :style="`overflow: auto; max-height: calc(100vh - ${190 + ($vuetify.breakpoint.lgAndUp ? 54 : 74)}px)`">
          <v-card-subtitle>
            Olá, no momento não temos nehum(a) <strong>{{descEvento("subtitulo")}}</strong> com inscrições abertas.<br>
            Fique ligado que em breve abriremos novos eventos.<br>
            <br>
            Att.<br>
            equipe <strong>Federação</strong>.
          </v-card-subtitle>
        </div>
        <div v-else :style="`overflow: auto; max-height: calc(100vh - ${190 + ($vuetify.breakpoint.lgAndUp ? 54 : 74)}px)`">
          <v-card-subtitle>
            Para efetuar sua inscrição <strong>{{descEvento("subtitulo")}}</strong>, é necessário estar cadastrado(a) em nosso sistema. {{textoComplementarMaisDeUmEventoAtivo}}
          </v-card-subtitle>
          <v-divider/>
          <v-card-text class="pa-5 flex-grow-1">
            <v-row>
              <!--autenticação-->
              <v-col cols="12" md="4">
                <v-card class="px-3">
                  <v-row>
                    <v-col cols="12" color="yellow">
                      <strong><v-icon large>mdi-account</v-icon> PASSO 1 - Autenticação/Cadastro</strong>
                      <v-divider/>
                    </v-col>
                  </v-row>
                  <v-row v-if="encontrou===0 || encontrou ===2">
                    <v-col cols="12" md="12">
                      <span class="subtitulo-passo">
                        <v-icon color="green" small>mdi-information-slab-box</v-icon> Informe seu CPF e data de nascimento para prosseguir com sua inscrição. Caso não esteja cadastrado, você será direcionado para o formulário de cadastro.
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-form ref="formAutenticacao" @submit.prevent="buscaCliente" v-model="formAutenticacaoValid" lazy-validation>
                        <AutenticacaoForm :value="autenticacao"/>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-btn color="primary" @click="buscaCliente" :disabled="!formAutenticacaoValid">Buscar</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="encontrou===3">
                    <v-col cols="12">
                      <span class="subtitulo-passo">
                        <v-icon color="red" small>mdi-alert</v-icon><strong>Confira seus Dados.</strong>
                        Mais de um Cliente encontrado com o CPF <strong>{{this.autenticacao.login}}</strong> e data de nascimento <strong>{{this.autenticacao.password}}</strong>.<br>
                        <strong>Entre em contato com a administração da Federação!</strong>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <span class="subtitulo-passo">
                        <v-icon color="green" small>mdi-check-outline</v-icon> <strong>Confira seus Dados.</strong>
                        Caso não esteja correto, entre em contato com a administração da Federação para regularizar.
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <strong>Nome</strong>: {{dadosCliente.current.nome}}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>E-mail</strong>: {{dadosCliente.current.email}}
                    </v-col>
                    <v-col cols="12" md="6">
                      <strong>Celular</strong>: {{dadosCliente.current.celular}}
                    </v-col>
                    <v-col cols="12" md="12">                      
                      <strong>Endereço</strong>: {{dadosCliente.current.endereco}}, {{dadosCliente.current.bairro}}, {{dadosCliente.current.cidade}}, {{dadosCliente.current.estado}}, , {{dadosCliente.current.cep}}
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <!--inscrição-->
              <v-col cols="12" md="4">
                <v-card class="px-3" :loading="loadingBuscaInscricao">
                  <v-row>
                    <v-col cols="12" color="yellow">
                      <strong><v-icon large>mdi-nintendo-game-boy</v-icon> PASSO 2 - Escolha do Evento</strong>
                      <v-divider/>
                    </v-col>
                  </v-row>
                  <v-row v-if="encontrou===1 && inscreveu===0">
                    <v-col cols="12">
                      <span class="subtitulo-passo">
                        <v-icon color="green" small>mdi-information-slab-box</v-icon> Escolha o evento desejado, a opção caso tenha, e clique em efetivar inscrição.
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-form ref="formInscricao" @submit.prevent="saveInscricao" v-model="formInscricaoValid" lazy-validation>
                        <InscrevaSeForm :value="inscricao" @sendIdCompEventoToInscrevase="recebeIdCompEvento($event)" 
                        :idCompEvento="this.eventoId" :disabledCampos="loadingBuscaInscricao"/>
                      </v-form>
                      <v-btn color="primary" @click="saveInscricao" :disabled="loadingBuscaInscricao || !formInscricaoValid">Efetivar Inscrição</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="inscreveu===1">                    
                    <v-col cols="12">
                      <span class="subtitulo-passo">
                        <v-icon color="green" small>mdi-check-outline</v-icon><strong> Inscrição realizada</strong>
                        Caso ainda não tenha pago sua inscrição, efetue o pagamento no passo 3.
                      </span>                      
                    </v-col>
                    <v-col cols="12" md="12">
                      <strong>Evento</strong>: {{dadosInscricao.current.descInscricaoCompeticao ? dadosInscricao.current.descInscricaoCompeticao : ""}}
                    </v-col>
                    <v-col cols="12" md="12" v-if="dadosInscricao.current.flgTipoComp === 'UN'">
                      <strong>Opção</strong>: {{dadosInscricao.current.provasFormatada ? dadosInscricao.current.provasFormatada : ""}}
                    </v-col>
                    <v-col cols="12" md="12">
                      <strong>Valor</strong>: R$ {{dadosInscricao.current.valorInscricao}}
                    </v-col>                 
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12"> 
                      <span class="subtitulo-passo">
                        <v-icon color="orange" small>mdi-alert-circle-outline</v-icon><strong> Não autenticado</strong>
                        Informe os dados de acesso e/ou cadastre-se no paso 1, para prosseguir com a inscrição.
                      </span> 
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <!--Pagamento-->
              <v-col cols="12" md="4">
                <v-card class="px-3" :loading="loadingPagamento">
                  <v-row>
                    <v-col cols="12" color="yellow">
                      <strong><v-icon large>mdi-cash-multiple</v-icon> PASSO 3 - Pagamento</strong>
                      <v-divider/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" v-if="inscreveu===1">
                      <span class="subtitulo-passo">
                        <v-icon color="green" small>mdi-check-outline</v-icon>
                        <strong> Fatura</strong>: {{dadosInscricao.current.fatura}} - <strong>Valor</strong>: R$ {{dadosInscricao.current.valorFatura}}
                      </span>
                      <p v-if="dadosInscricao.current.statusPagamento === 'A'"> 
                        <span class="subtitulo-passo">
                          <v-icon color="green" small>mdi-information-slab-box</v-icon> {{textoFormaPagamento}}
                        </span>
                        <v-form ref="formPagamento" @submit.prevent="efetuarPagamento" v-model="formPagamentoValid" lazy-validation>
                          <CartaoCreditoForm v-model="dadosInscricao.current" titulo="" :disabledCampos="loadingPagamento"/>
                        </v-form>
                        <v-btn v-if="informouFormaPagamento" color="primary" @click="efetuarPagamento" 
                        :disabled="loadingPagamento || !formPagamentoValid">{{getAcaoFormaPagamento}}</v-btn>
                      </p>
                      <p v-else-if="dadosInscricao.current.statusPagamento === 'I'"> 
                        <span class="subtitulo-passo">
                          <v-icon color="green" small>mdi-check-outline</v-icon> Boleto gerado com sucesso. Clique em baixar o boleto para visualizá-lo. Caso já tenha pago, desconsidere essa mensagem.
                          <a target="_blank" :href="dadosInscricao.current.urlBoleto">Baixar Boleto</a>
                        </span>
                      </p>
                      <p v-else-if="dadosInscricao.current.statusPagamento === 'P'"> 
                        <span class="subtitulo-passo">
                          <v-icon color="green" small>mdi-check-outline</v-icon> Pagamento Recebido com sucesso
                        </span>
                      </p>
                    </v-col>           
                    <v-col cols="12" v-else> 
                      <span class="subtitulo-passo">
                        <v-icon color="orange" small>mdi-alert-circle-outline</v-icon> Ao concluir sua inscrição, você porderá escolher a forma de pagamento e efetivar sua inscrição.
                      </span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
        <v-divider/>
        <v-card-actions v-if="existeCompeticaoativa">
          <v-spacer/>
          <v-btn color="primary" @click="limparDados">Reiniciar Inscrição</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AppLogo from "../../components/app/AppLogo";
import InscrevaSeForm from "./components/InscrevaSeForm";
import AutenticacaoForm from "./components/AutenticacaoForm";
import CadastreSeForm from "../../components/shared/forms/CadastreSeForm";
import CartaoCreditoForm from '../../components/shared/forms/CartaoCreditoForm';
import {clienteNovoCadastro} from "../../api/clientes";
import {findInscricaoPorToken, createPorToken as salvarInscricao} from "../../api/inscricoes";
import {findAllCompeticoesAtivasPublica} from "../../api/competicoes";
import {efetuaPagamentoIntegracaoToken} from "../../api/faturas";
import {doLoginAsClient as autenticarCliente} from "@/api/auth";
import {ApiError} from "../../api/core";
import {downloadBoleto} from "../../api/relatorios";

export default {
  components: {AppLogo, InscrevaSeForm, CadastreSeForm, AutenticacaoForm, CartaoCreditoForm},
  name: "InscrevaSe",
  data() {
    return {
      idCompEvento: 0,
      tituloEvento: "",
      competicaoAtiva: {},
      existeCompeticaoativa: false,
      formCliente: {},
      editDialogClienteOpened: false,
      inscricao: {
        id: null,
        descricao: '',
        descInscricaoCompeticao: '',
        idCompEvento: null,
        flgTipoComp: null,
        flgValorUnico: null,
        valorInscricao: null,
        unicas: {},
        unicasId: null,
      },
      autenticacao: {
        login:    "",
        password: ""
      },
      dadosCliente: {
        token: "",
        current: {}
      },
      dadosInscricao: {
        current: {
          descInscricaoCompeticao: "", 
          valorInscricao: null, 
          provasFormatada: "",
          provas: [], 
          fatura: "",
          statusPagamento: "",
          valorFatura: null,
          idFatura: null,
          formaPgtoIntegra: 0,
        }
      },
      encontrou: 0,
      inscreveu: 0,
      formClienteValid: false,
      botoesCadastroClienteVisivel: true,
      formAutenticacaoValid: false,
      formInscricaoValid: false,
      formPagamentoValid: false,
      loading: false,
      loadingFormCliente: false,
      loadingBuscaInscricao: false,
      loadingPagamento: false,
    }
  },
  computed: {
    getAcaoFormaPagamento() {
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 4) return "Efetuar Pagamento";
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 3) return "Gerar Boleto";
      return "";
    },
    isApenasUmEventoAtivo(){
      if (this.existeCompeticaoativa && parseInt(this.competicaoAtiva.elements.length) === 1){
        return true;
      }
      return false;
    },
    textoComplementarMaisDeUmEventoAtivo(){
      return this.isApenasUmEventoAtivo ? '' : 'Após a autenticação, você poderá escolher o evento desejado e efetivar sua inscrição.';
    },
    eventoId() {
      const id = this.$route.params.id;
      return id ? parseInt(id) : 0;      
    },
    informouFormaPagamento(){
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 2) return false;
      return this.dadosInscricao.current.formaPgtoIntegra && this.dadosInscricao.current.formaPgtoIntegra !== "";
    },
    textoFormaPagamento(){
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 4) return "Informe os dados do cartão de crédito para efetuar o pagamento.";
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 3) return "Clique no botão abaixo para gerar o boleto de pagamento.";
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 2) return "Siga as instruções de pagamento.";
      return "Escolha a forma de pagamento desejada, e siga as instruções de pagamento.";
    },
    mensagemSucessoAposPagamentos(){
      if (parseInt(this.dadosInscricao.current.formaPgtoIntegra) === 3) return "Boleto gerado e disponível. Clique no link para exibir/pagar o boleto e efetivar sua inscrição";
      return "Pagamento efetuado com sucesso.";
    }
  },
  methods: {
    descEvento(localMensagem) {
      if (this.isApenasUmEventoAtivo){
        return ( localMensagem==="titulo" ? "Eventos da FBCMG. Evento: " : "na(o) evento " ) + this.competicaoAtiva.elements[0].descCompEvento;
      } else {
        return ( localMensagem==="titulo" ? "Inscrições nos " : "nos " ) + 'Eventos da FBCMGOLFE ';
      }
    },   
    recebeIdCompEvento(idCompEventoSelecionado){
      this.idCompEvento = idCompEventoSelecionado;
      this.buscaInscricaoPorToken();
    },
    async verificaSeTemCompeticoesAtivas() {
      try {
        this.loading = true;
        this.competicaoAtiva = await findAllCompeticoesAtivasPublica(1, this.eventoId, {});
        if (this.competicaoAtiva.elements.length > 0) this.existeCompeticaoativa = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível verificar se existe Evento ativo!`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }        
    },
    async buscaCliente() {
      if (this.autenticacao.login === "" || this.autenticacao.password === "") {
        this.$toast.error("Informe o CPF e a data de nascimento para prosseguir com a inscrição.", {
              timeout: 6000
            });
        return false;
      }
      try {
        this.loading = true;
        this.dadosCliente = await autenticarCliente(
          this.autenticacao.login,
          this.autenticacao.password
        );
        this.encontrou = 1;
      } catch (err) {
        this.encontrou = 2;
        if (err instanceof ApiError) {
          if (err.message === "duplicado"){
            this.encontrou = 3;
          }
        } else {
          this.encontrou = 2;
        }
        
        if (this.encontrou===2){
          this.$swal({
                title: 'Cliente não encontrado, ir para o cadastro?',
                html: `Não encontramos nenhum cadastro para o CPF <strong>${this.autenticacao.login}</strong> e data de nascimento <strong>${this.autenticacao.password}</strong> informados.`,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Não, vou revisar os dados informados',
                confirmButtonText: 'Sim, quero me cadastrar'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.editDialogClienteOpened=true;
                }
              });
        }
      } finally {
        this.loading = false;
      }
    },    
    async saveCliente() {
      if(!this.$refs.form.validate()) return;
      try {
        this.loading = true;
        this.loadingFormCliente = true;
        this.botoesCadastroClienteVisivel = false;
        const {dados} = await clienteNovoCadastro(this.formCliente)
        this.$toast.success(`Cadastro efetuado com sucesso. Enviamos um e-mail com alguns informações.`, {
          timeout: 3000
        });
        this.autenticacao.login = dados.cpf;
        this.autenticacao.password = dados.dtNascimento;

        this.buscaCliente();
        this.editDialogClienteOpened = false;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível realizar o cadastro. Entre em contato com a Federação!.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
        this.loadingFormCliente = false;
        this.botoesCadastroClienteVisivel = true;
      }
    },
    async buscaInscricaoPorToken() {
      try {
        this.inscreveu = 1;
        this.loading = true;
        this.loadingBuscaInscricao = true;
        this.dadosInscricao = await findInscricaoPorToken(
          this.dadosCliente.token,
          this.idCompEvento
        );
        console.log(this.dadosInscricao);
        if (!this.dadosInscricao.current){
          this.inscreveu = 0;
          this.dadosInscricao.current = {
            descInscricaoCompeticao: "", 
            valorInscricao: null, 
            provasFormatada: [], 
            fatura: "",
            statusPagamento: "",
            urlBoleto: "",
            idFatura: null,
          }
        }
      } catch (err) {
        this.inscreveu = 2;
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Ocorreu um erro.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
        this.loadingBuscaInscricao = false;
      }
    },
    async saveInscricao() {
      if(!this.$refs.formInscricao.validate()) return;
      try {
        this.loading = true;
        this.loadingFormCliente = true;
        this.loadingBuscaInscricao = true;
        await salvarInscricao(this.dadosCliente.token, this.inscricao)
        this.$toast.success(`Inscrição efetuada com sucesso.`, {
          timeout: 3000
        });
        this.buscaInscricaoPorToken();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível realizar a inscrição. Entre em contato com a Federação!.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
        this.loadingFormCliente = false;        
        this.loadingBuscaInscricao = false;
      }
    },
    async efetuarPagamento() {
      if(!this.$refs.formPagamento.validate()) return;
      try {
        this.loading = true;
        this.loadingPagamento = true;
        await efetuaPagamentoIntegracaoToken(this.dadosCliente.token, this.dadosInscricao.current)
        this.$toast.success(this.mensagemSucessoAposPagamentos, {
          timeout: 3000
        });
        this.buscaInscricaoPorToken();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível realizar a pagamento. Entre em contato com a Federação!.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;     
        this.loadingPagamento = false;
      }
    },    
    async verBoleto(idFatura) {
      let item = {
        formatoSaida: "pdf",
        id: idFatura,
        tk: this.dadosCliente.token,
      };
      this.loading = true;
      await downloadBoleto(item);
      this.loading = false;
    },
    limparDados(){
      this.idCompEvento = 0;
      this.autenticacao.login = "";
      this.autenticacao.password = "";
      this.formCliente = {};
      this.editDialogClienteOpened = false;
      this.inscricao = {
        id: null,
        descricao: '',
        descInscricaoCompeticao: '',
        idCompEvento: null,
        flgTipoComp: null,
        flgValorUnico: null,
        valorInscricao: null,
        unicas: {},
        unicasId: null,        
      };
      this.dadosCliente.token = "";
      this.dadosCliente.current = {};
      this.dadosInscricao = {}
      this.dadosInscricao.current = {}
      this.dadosInscricao.current.descInscricaoCompeticao = "";
      this.dadosInscricao.current.valorInscricao = null;
      this.dadosInscricao.current.provasFormatada = "";
      this.dadosInscricao.current.provas = [];
      this.dadosInscricao.current.fatura = "";
      this.dadosInscricao.current.statusPagamento = "",
      this.dadosInscricao.current.urlBoleto = "",
      this.dadosInscricao.current.valorFatura = null,
      this.dadosInscricao.current.formaPgtoIntegra = 4,      
      this.dadosInscricao.current.idFatura = null;
      this.encontrou = 0;
      this.inscreveu = 0;
      this.formClienteValid = false;
      this.botoesCadastroClienteVisivel = true;
      this.formAutenticacaoValid = false;
      this.formInscricaoValid = false;
      this.formPagamentoValid = false;
      this.loading = false;
      this.loadingFormCliente = false;
      this.loadingBuscaInscricao = false;
      this.loadingPagamento = false;
    }
  },
  mounted() {
    this.verificaSeTemCompeticoesAtivas();
  }
}
</script>

<style scoped lang="scss">
.background {
  background-image: url('../../assets/backgrounds/bg01.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
  flex: 1;

  .logo {
    padding: 5px;

    img {
      height: 60px;
    }
  }

}
.subtitulo-passo {
  font-size: 0.9em;
  color: rgb(40, 41, 39);
}
</style>